﻿import { CannedResponseAvailability } from '../../enums/index';

export interface ITicketCannedResponseRequest {
    id: number;
    title: string;
    message: string;
    availability: CannedResponseAvailability;
    ownerId: number;
}
